import { DeleteClientCreditCardRequest } from 'vopay';
import { useState } from 'react';
import { useApi } from '#shared/providers/Api';

export default function useDeleteCreditCard() {
  const api = useApi();
  const [deleting, setDeleting] = useState(false);

  // PortalUser omitted: the handler reads only CreditCardToken (verified against
  // lib/www/routes/v2/credit_card.php) — the backend takes the user from the JWT. As with
  // useDeleteBankAccount, this request type declares PortalUser required.
  async function deleteCreditCard(params: Omit<DeleteClientCreditCardRequest, 'PortalUser'>) {
    try {
      setDeleting(true);
      const res = await api.postDeleteClientCreditCard(params);

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setDeleting(false);
    }
  }

  return { deleting, deleteCreditCard };
}
